export enum AssignmentStatus {
  Overdue,
  Incomplete,
  Completed
}
